    (function() {

        /**
         * Handles WCPF checkbox filters using URL parameters.
         *
         * @param {Event} event Click event.
         */
        function handleProductFilter(event) {
            var item = event.target.closest('.wcpf-checkbox-item');

            if (!item) {
                return;
            }

            var input = item.querySelector('.wcpf-input-checkbox');

            if (!input) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            var url = new URL(window.location.href);
            var name = input.getAttribute('name');
            var value = input.value;
            var currentValue = url.searchParams.get(name);
            var values = [];
            var isChecked = input.checked;

            if (currentValue) {
                values = currentValue.split(',');
            }

            /*
             * At capture stage the checkbox hasn't changed yet,
             * so reverse its current checked state.
             */
            if (!isChecked) {
                if (values.indexOf(value) === -1) {
                    values.push(value);
                }
            } else {
                values = values.filter(function(itemValue) {
                    return itemValue !== value;
                });
            }

            if (values.length) {
                url.searchParams.set(name, values.join(','));
            } else {
                url.searchParams.delete(name);
            }

            /*
             * Remove pagination when changing filters.
             */
            url.searchParams.delete('product-page');
            url.searchParams.delete('paged');

            window.location.href = url.toString().replace(/%2C/gi, ',');
        }

        document.addEventListener('click', handleProductFilter, true);
    })();